import * as XLSX from 'xlsx';
import { translate } from '../i18n';
import {
  formatAppliedAt,
  formatGender,
  formatGrade,
  formatPaymentStatus,
  formatStatus,
} from './participantList';

function sanitizeFileName(name) {
  return (name || translate('participants.excel.defaultFileName')).replace(/[/\\?%*:|"<>]/g, '_').trim();
}

export function exportParticipantsToExcel(participants, tournamentName) {
  if (!participants?.length) return;

  const col = (key) => translate(`participants.excel.columns.${key}`);
  const rows = participants.map((p) => ({
    [col('id')]: p.id,
    [col('competitionCode')]: p.competitionCode,
    [col('competitionName')]: p.competitionName,
    [col('name')]: p.participantName,
    [col('association')]: p.associationName,
    [col('gym')]: p.gymName ?? translate('common.noGym'),
    [col('coach')]: p.coachName,
    [col('grade')]: formatGrade(p.grade),
    [col('birth')]: p.birth,
    [col('gender')]: formatGender(p.gender),
    [col('height')]: p.height ?? '',
    [col('participantPhone')]: p.participantPhone,
    [col('parentPhone')]: p.parentPhone,
    [col('status')]: formatStatus(p.status),
    [col('orderId')]: p.orderId,
    [col('paymentMethod')]: p.paymentMethod,
    [col('paymentStatus')]: formatPaymentStatus(p.paymentStatus),
    [col('amount')]: p.amount ?? '',
    [col('appliedAt')]: p.appliedAt ? formatAppliedAt(p.appliedAt) : '',
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, translate('participants.excel.sheetName'));

  const colWidths = [
    { wch: 8 },
    { wch: 12 },
    { wch: 24 },
    { wch: 12 },
    { wch: 20 },
    { wch: 18 },
    { wch: 12 },
    { wch: 10 },
    { wch: 14 },
    { wch: 8 },
    { wch: 10 },
    { wch: 14 },
    { wch: 14 },
    { wch: 10 },
    { wch: 22 },
    { wch: 10 },
    { wch: 12 },
    { wch: 12 },
    { wch: 18 },
  ];
  worksheet['!cols'] = colWidths;

  const fileLabel = translate('participants.excel.fileLabel');
  const fileName = `${sanitizeFileName(tournamentName)}_${fileLabel}_${new Date().toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
}
